<template>
    <div class="modal fade" id="confirmationRejectCertifie" tabindex="-1" role="dialog" aria-labelledby="confirmationRejectCertifie" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmationModalLabel">{{title}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="order && order.typeOrder!=null" >
                    <p><strong>{{message}}</strong></p>
                    <p><strong>{{$t('string.msg.order.type.label.modal')}}:</strong> {{' ' + $t(order.typeOrder) + ' - ' + order.description}}</p>
                    <p><strong>{{$t('string.msg.order.type.label.date')}}:</strong> {{' ' + new Date(order.dateOrder).toLocaleDateString()}} - {{new Date(order.dateOrder).toLocaleTimeString()}} </p>
                    <p><strong>{{$t('string.msg.order.type.label.distance')}}:</strong> {{' ' + $t((Number(order.distance)/1000).toFixed(2)) + ' KM'}} </p>
                    <p v-if="order.systemUser.customerUser"><strong>{{$t('string.msg.order.type.label.trucker')}}:</strong> {{' ' + order.systemUser.firstName + ' '  +  order.systemUser.lastName}} </p>  

                    <label for="inputAddress" class="col-form-label">
                        <code class="highlighter-rouge">*</code> {{$t('response.reject.order.justify.msg')}}
                    </label>
                
                <input type="text" v-model="order.justifyReject" class="form-control">

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="$emit('confirmation-return', 0)">{{cancelText}}</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="$emit('confirmation-return', 1)">{{yesText}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["title", "message", "cancelText", "yesText","order"],
        watch:{
            'order'(){
                this.order = this.order;
                this.order.justifyReject = this.order.justifyReject;
            }
        },
        methods:{
            
        }
    }
</script>